import { render, staticRenderFns } from "./cabecera.vue?vue&type=template&id=3bdc1ea6&"
import script from "./cabecera.vue?vue&type=script&lang=js&"
export * from "./cabecera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports